import StudentEventCalendarAPI from '@/apis/business/student/student-event-calendar-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,
  state: {
    eventCalendars: [],
    calendarDate: new Date(),
    eventCalendarRecently: []
  },
  mutations: {
    /**
     * set list event calendar
     * @param {*} state
     * @param {*} data
     * VDDung1
     */
    setEventCalendars (state, data) {
      state.eventCalendars = data
    },

    /**
     * set giá trị thời gian cho calendar
     * @param {*} state
     * @param {*} date
     * VDDung1
     */
    setCalendarDate (state, date) {
      state.calendarDate = date
    },

    /**
     * set giá trị lịch 7 ngày tới đây
     * @param {*} state
     * @param {*} data
     */
    setEventCalendarRecently (state, data) {
      state.eventCalendarRecently = data
    }
  },

  actions: {
    /**
     * Lấy danh sách lịch học theo tuần của học sinh
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    getListEventCalendar (context, param) {
      return new Promise((resolve, reject) => {
        StudentEventCalendarAPI.getAsync('list', { params: param })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setEventCalendars', res?.Data)
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách lịch 7 ngày tới đây
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    getEventCalendarRecently (context, param) {
      return new Promise((resolve, reject) => {
        StudentEventCalendarAPI.getAsync('list', { params: param })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setEventCalendarRecently', res?.Data)
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
